import { Component, Input } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { ImageModalComponent } from '../shareModule/component/chat/chatbot/image-modal.component';
import { SharedService } from '../shareModule/services/shared.service';
import { CommonService } from '../shareModule/services/common.service';

@Component({
  selector: 'app-promo-card',
  templateUrl: './promo-card.component.html',
  styleUrl: './promo-card.component.scss',
})
export class PromoCardComponent {
  @Input()
  item: any;

  public imgUrl = environment.ImageUrl

  constructor(private modalService: NgbModal, private bottomSheet: MatBottomSheet, private sharedService: SharedService, private commonService: CommonService){}

  public handleError(error){
    this.commonService.handleError(error)
  }
  public get isMobile(): boolean {
    return this.sharedService.isBrowser() && window.innerWidth <= 992;
  }
  public openImage(url, otherImages=[]) {
   
    let instance;
    if(this.isMobile){
      const bs =  this.bottomSheet.open(ImageModalComponent, {
        panelClass: 'bottom-sheet-1'
      });
      instance = bs.instance
      instance.otherImages = otherImages.filter(img => !!img).map(img => environment.ImageUrl + img)

    }else{
      const modal = this.modalService.open(ImageModalComponent, {
        size: 'sm',
        windowClass: 'image-modal',
      });
      instance = modal.componentInstance;

    }
    instance.title = this.item.serviceComment
    instance.descr = this.item.serviceDescription;
    instance.imageSrc = environment.ImageUrl + url;
    
 
  }
}
